import { createSlice } from '@reduxjs/toolkit';
import { CMSContent } from 'types/cmsType';

interface CMSState {
  cms: CMSContent;
}

const initialState: CMSState = {
  cms: {} as CMSContent,
};

const cmsSlice = createSlice({
  name: 'cms',
  initialState,
  reducers: {
    setCMS(state, action) {
      state.cms = action.payload;
    },
  },
});

export const { setCMS } = cmsSlice.actions;
export default cmsSlice.reducer;
